<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-sm="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-select
              ref="payableByDropDown"
              name="payable_by"
              label="پرداخت توسط"
              rules="required"
              validation-container-class="col-12"
              input-class="form-control"
              :data-source="payableTypes"
              data-text-field="name"
              data-value-field="value"
              v-model="dataForm.purchase_with"
            />
            <bita-input
              type="text"
              name="national_code"
              label="کدملی راننده"
              rules="required|irani"
              validation-container-class="col-lg-12"
              input-class="form-control"
              v-model.lazy="dataForm.driver_national_code"
              @change="findDriver"
              subtitle="جستجو فقط با کد‌ملی کامل و صحیح"
            />
            <div class="form-group col-lg-12">
              <label>راننده</label>
              <input
                :disabled="true"
                class="form-control"
                v-model="dataForm.driver_name"
              />
            </div>
            <!-- <bita-autocomplete
              ref="driversDropDown"
              v-if="drivers.length > 0"
              name="drivers"
              label="راننده"
              :template="
                (e) => (e.user ? `${e.name} - ${e.user.national_code}` : '-')
              "
              :data-text-field="'name'"
              :data-value-field="'id'"
              rules="required"
              validation-container-class="col-12"
              input-class="form-control"
              :data-source="serverDrivers"
              @filtering="filterDrivers"
              v-model="dataForm.driver_id"
              subtitle="جستجو بر اساس کد‌ملی راننده می‌باشد"
            /> -->
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!propsData.id"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        v-if="propsData.id && assignToDriver"
        type="primary"
        title="بروزرسانی"
        icon="fa fa-check"
        btn-width="100px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        v-show="!assignToDriver"
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="10px"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "@progress/kendo-theme-default/dist/all.css";

import {
  AutoComplete,
  DropdownsInstaller,
} from "@progress/kendo-dropdowns-vue-wrapper";
import "@progress/kendo-ui/js/kendo.dropdownlist";
export default {
  use: { DropdownsInstaller },
  components: { AutoComplete },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    drivers: { type: Array },
    customers: { type: Array },
    onSubmit: {},
    propsData: {
      type: Object,
      default: {
        driver_id: 0,
      },
    },
  },
  data() {
    return {
      colWidth: "col-lg-12",
      dataForm: {},
      payableTypes: [
        { name: "راننده", value: 1 },
        { name: "باربری", value: 2 },
      ],
      users: [],
      serverDrivers: [],
      serverDriversHistory: [],
      assignToDriver: false,
    };
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
  },
  methods: {
    findDriver() {
      if (this.$ssnIsValid(this.dataForm.driver_national_code)) {
        this.$persistClient("post", `drivers/national-code`, {
          national_code: this.dataForm.driver_national_code,
        }).then((res) => {
          if (res.data.is_success) {
            let response = res.data.data;
            this.dataForm.driver_name = response.name + " " + response.family;
            this.dataForm.driver_id = response.model_id;
            this.assignToDriver = true;
          }
        })
      }
    },
    filterDrivers(e) {
      if (!e.filter) return;
      if (e.filter.value == "") {
        this.serverDrivers = this.drivers;
        return;
      }
      this.serverDrivers = _.filter(this.drivers, function(item) {
        return item && item.user && item.user.national_code != null
          ? item.user.national_code.includes(e.filter.value)
          : false;
      });
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
      });
    },
    reset() {
      let dropDowns = ["driversDropDown", "payableByDropDown"];
      for (let ref of dropDowns) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
      this.$refs.form.reset();
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
